import React, { useEffect, useRef, useState } from "react";
import Modal from "../../components/Modal/Modal";
import { NOTE_MAX_LENGTH } from "../../Apihander/Note/Note";
import { errorToast } from "../../utils/notificationUtils";
import { Spinner, fmt } from "./notesShared";

export const NoteEditorModal = ({ title = "Edit note", timestampSec, initialValue, saving, onSave, onClose }) => {
    const [value, setValue] = useState(initialValue || "");
    const textareaRef = useRef(null);

    useEffect(() => {
        const textarea = textareaRef.current;
        if (!textarea) return;
        textarea.focus();
        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
    }, []);

    const handleSave = () => {
        const text = value.trim();
        if (!text) {
            errorToast("Note cannot be empty");
            return;
        }
        onSave(text);
    };

    return (
        <Modal onClose={onClose} modaltxt={title} closeButtonDisabled={saving}>
            <div className="nt nt-modal">
                <div className="nt-editor-head">
                    <span className="nt-editor-at">Saved at <b className="nt-ts">{fmt(timestampSec)}</b> in the recording</span>
                    <span className="nt-count">{`${value.length}/${NOTE_MAX_LENGTH}`}</span>
                </div>
                <textarea
                    ref={textareaRef}
                    className="form-control input-field nt-textarea"
                    rows={4}
                    placeholder="Write your note…"
                    value={value}
                    maxLength={NOTE_MAX_LENGTH}
                    disabled={saving}
                    onChange={(e) => setValue(e.target.value)}
                />
                <button type="button" className="nt-btn block nt-modal-cta" disabled={saving} onClick={handleSave}>
                    {saving ? <Spinner /> : "Save"}
                </button>
            </div>
        </Modal>
    );
};
